export enum Route {
  ROOT = "",
  HOME = "/",
  RESUME = "/resume",
}
